var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position"},[_c('button',{staticClass:"btn btn-danger d-flex justify-content-center align-items-center",on:{"click":_vm.onClick}},[_c('i',{staticClass:"flaticon-delete-1"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }